var giphy_viewer_default = {
  "giphyWrapper": "Qtq2S",
  "giphy_player": "XxUPE",
  "playIcon": "RbG-o",
  "gifRatio": "eUxxZ"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
